/* src/components/create-update-company-type-modal/create-update-company-type-modal.component.scss */
:host {
  display: block;
}
.modal-full-width {
  --vwui-modal--max-width: 60vw;
}
/*# sourceMappingURL=create-update-company-type-modal.component-P6XB5TRD.css.map */
